import {Group, Stack, Text} from "@mantine/core";
import IconArrowUpRight from "../../assets/arrow-up-right.svg?react";
import classes from "./RelatedItem.module.css";

type RelatedItemProps = {
    title: string;
    description?: string | null;
    href: string;
    linkComponent?: React.ElementType;
    linkProps?: Record<string, unknown>;
    leadingIcon?: React.ReactNode;
    debugScore?: number | null;
};

export const RelatedItem = ({
    title,
    description,
    href,
    linkComponent: LinkComponent = "a",
    linkProps,
    leadingIcon,
    debugScore,
}: RelatedItemProps) => {
    return (
        <LinkComponent
            href={href}
            className={classes.item}
            {...linkProps}
        >
            <Group gap="xs" wrap="nowrap" className={classes.itemContent}>
                {leadingIcon && (
                    <span className={classes.leadingIcon}>{leadingIcon}</span>
                )}
                <Stack gap={2} style={{flex: 1, overflow: "hidden"}}>
                    <Text
                        size="sm"
                        fw={500}
                        className={classes.itemTitle}
                    >
                        {title}
                    </Text>
                    {description && (
                        <Text size="xs" c="dimmed" className={classes.itemDescription}>
                            {description}
                        </Text>
                    )}
                    {debugScore != null && (
                        <Text size="xs" c="grape" ff="monospace">
                            {(debugScore * 100).toFixed(2)}%
                        </Text>
                    )}
                </Stack>
                <IconArrowUpRight className={classes.chevron} width={16} />
            </Group>
        </LinkComponent>
    );
};
